import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaExternalLinkAlt, FaSearch } from 'react-icons/fa';
import { AppWrap } from '../../wrapper';
import images from "../../constants/images";
import './Work.scss';

const works = [
  {
    title: "Travel Agency - Ghum Gham",
    description: "This is about the landing page of a travel agency. Which is for the Frontend Design Fest organized by Whitehouse Innovator.",
    projectLink: "https://github.com/Ayuscal/Travel-Agency",
    codeLink: "https://github.com/Ayuscal/Travel-Agency",
    imageUrl: images.GhumGham, // replace with real image
    tags: ['Travel']
  },
 {
    title: "Emotion Detection System",
    description: "The system processes input data using image processing and feature extraction techniques, then applies supervised learning algorithms to classify emotions such as happiness, sadness, anger, fear, surprise, and neutrality. This project demonstrates the practical use of machine learning, data preprocessing, and model evaluation to build an intelligent system capable of understanding human emotions.",
    projectLink: "https://github.com/Ayuscal/Emotion-Detection",
    codeLink: "https://github.com/Ayuscal/Emotion-Detection",
    imageUrl: images.emotion_detection, // replace with real image
    tags: ['Emotion Detection']
  },
  {
    title: "Movie Recommendation System",
    description: "The system uses recommendation techniques such as content-based filtering and collaborative filtering to analyze user behavior and movie features. By computing similarity scores between users or items, the system provides personalized recommendations. This project demonstrates how data analysis and machine learning algorithms can be used to enhance user experience in entertainment platforms.",
    projectLink: "https://github.com/Ayuscal/Movie-Recomendation",
    codeLink: "https://github.com/Ayuscal/Movie-Recomendation",
    imageUrl: images.movie_reco, // replace with real image
    tags: ['Movie Recommendation']
  },
];

const Work = () => {
  const [filteredWorks, setFilteredWorks] = useState(works);
  const [activeFilter, setActiveFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const categories = ['All', ...new Set(works.flatMap(work => work.tags))];

  useEffect(() => {
    filterWorks(activeFilter, searchTerm);
  }, [searchTerm, activeFilter]);

  const filterWorks = (category, term) => {
    if (category === 'All') {
      setFilteredWorks(works.filter(work =>
        work.title.toLowerCase().includes(term.toLowerCase()) ||
        work.description.toLowerCase().includes(term.toLowerCase())
      ));
    } else {
      setFilteredWorks(works.filter(work =>
        work.tags.includes(category) &&
        (work.title.toLowerCase().includes(term.toLowerCase()) ||
          work.description.toLowerCase().includes(term.toLowerCase()))
      ));
    }
  };

  const handleFilterClick = (category) => {
    setActiveFilter(category);
    filterWorks(category, searchTerm);
  };

  return (
    <section className="py-16 bg-gray-50 max-w-full">
      <div className=" mx-auto px-4 w-full">
        <h2 className="text-4xl font-bold text-center mb-12">My Recent <span className="text-blue-600">Projects</span></h2>

        <div className="mb-8">
          <div className="relative w-full max-w-md mx-auto">
            <input
              type="text"
              placeholder="Search projects..."
              className="w-full px-4 py-2 rounded-full border-2 border-gray-300 focus:outline-none focus:border-blue-500"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <FaSearch className="absolute right-3 top-3 text-gray-400" />
          </div>
        </div>

        <div className="overflow-x-auto whitespace-nowrap scrollbar-hide mb-8">
          <div className="flex gap-4">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => handleFilterClick(category)}
                className={`px-4 py-2 rounded-full transition-all duration-300 ${activeFilter === category
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>


        <AnimatePresence>
          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
            layout
          >
            {filteredWorks.map((work, index) => (
              <motion.div
                key={work.title}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 50 }}
                transition={{ duration: 0.5 }}
                layout
              >
                <div className="relative h-48">
                  <img src={work.imageUrl} alt={work.title} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity duration-300">
                    <a href={work.projectLink} target="_blank" rel="noreferrer" className="text-white hover:text-blue-300 transition-colors">
                      <FaExternalLinkAlt size={24} />
                    </a>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2">{work.title}</h3>
                  <p className="text-gray-600 mb-4">{work.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {work.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default AppWrap(Work, 'work');